class GiftCardForm extends window.HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initialize();
  }

  initialize() {
    this.addToCartButton = this.querySelector('[data-gift-card-submit]');
    this.giftOptions = this.querySelector('[data-gift-options]');
    this.isGiftCheckbox = this.querySelector('[data-gift-toggle]');
    this.recipientEmailInput = this.querySelector('[data-gift-recipient-email]');
    this.recipientNameInput = this.querySelector('[data-gift-recipient-name]');
    this.messageInput = this.querySelector('[data-gift-message]');
    this.sendOnInput = this.querySelector('[data-gift-send-on]');
    this.recipientEmailError = this.querySelector('[data-gift-email-error]');

    if (this.addToCartButton) {
      this.addToCartButton.addEventListener('click', () => this.addToCart());
    }

    if (this.isGiftCheckbox && this.giftOptions) {
      this.isGiftCheckbox.addEventListener('change', () => {
        const isGift = this.isGiftCheckbox.checked;
        this.giftOptions.classList.toggle('active', isGift);
        this.giftOptions.inert = !isGift;

        if (!isGift) {
          this.resetGiftFields();
        }
      });
    }

    if (this.recipientEmailInput) {
      this.recipientEmailInput.addEventListener('input', () => this.setEmailError(''));
    }
  }

  setEmailError(message) {
    this.recipientEmailError.textContent = message;
    if (message) {
      this.recipientEmailInput.setAttribute('aria-invalid', 'true');
    } else {
      this.recipientEmailInput.removeAttribute('aria-invalid');
    }
  }

  resetGiftFields() {
    this.recipientEmailInput.value = '';
    this.recipientNameInput.value = '';
    this.messageInput.value = '';
    this.sendOnInput.value = '';
    this.setEmailError('');
  }

  addToCart() {
    const cartForm = this.closest('cart-form');
    if (!cartForm) {
      console.error('No cart form found.');
      return;
    }

    const dataForm = JSON.parse(cartForm.getAttribute('data-form'));
    const itemId = Object.keys(dataForm.items)[0];
    const itemQuantity = dataForm.items[itemId].quantity;

    const payload = {
      id: dataForm.items[itemId].id,
      quantity: itemQuantity,
      properties: {}
    };

    const isGift = this.isGiftCheckbox.checked;
    if (isGift) {
      const recipientEmail = this.recipientEmailInput.value.trim();
      const recipientName = this.recipientNameInput.value;
      const message = this.messageInput.value;
      const sendOn = this.sendOnInput.value;
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      if (!recipientEmail) {
        this.setEmailError("Email can't be blank.");
        this.recipientEmailInput.focus();
        return;
      }

      if (!emailPattern.test(recipientEmail)) {
        this.setEmailError("Enter a valid email.");
        this.recipientEmailInput.focus();
        return;
      }

      this.setEmailError('');

      payload.properties['__shopify_send_gift_card_to_recipient'] = 'on';
      if (recipientEmail) payload.properties['Recipient email'] = recipientEmail;
      if (recipientName) payload.properties['Recipient name'] = recipientName;
      if (message) payload.properties['Message'] = message;
      if (sendOn){
        payload.properties['Send on'] = sendOn;
        payload.properties['__shopify_offset'] = new Date().getTimezoneOffset().toString();
      }
    }

    cartForm?.formDataAPI?.updateItems(payload);
    cartForm?.reqCart();
  }
}

window.customElements.define('gift-card-form', GiftCardForm);
